import { Component, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { AuthService } from '@s-services/auth.service';
import { UiService } from '@s-services/ui.service';
import { environment } from '@s-env/environment';

import { MaterialModule } from '@s-app/material.module';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss'],
    imports: [
    MaterialModule,
    FormsModule
]
})
export class SignupComponent {

  constructor(private dialog: MatDialog,
    private authService: AuthService,
    private router: Router,
    public uiService: UiService) { }

  checkPasswordConsistency(form: NgForm) {
    if (form.controls['pwd1'].value !== form.controls['pwd2'].value) {
      form.controls['pwd2'].setErrors({ 'incorrect': true });
    }
  }

  onSignupWithPassword(form: NgForm): void {
    const creds = {
      email: form.value.email,
      password: form.value.pwd1
    };
    this.uiService.loading.next(true);
    this.authService.signupWithPassword(creds).then(() => {
      this.signupSuccessful();
    }).catch(error => {
      this.uiService.showSimpleSnackbar(error, 'OK');
      this.uiService.loading.next(false);
    });
  }

  private signupSuccessful(): void {
    this.router.navigate(['/konto-verifizieren']).then(() => {
      this.uiService.loading.next(false);
      this.uiService.showSimpleSnackbar('Konto erstellt, bitte bestätigen Sie Ihre Email-Adresse!', 'OK');
    });
  }
}
